

(() => {
  if (window.OvriumProductInteractionsLoaded) return;
  window.OvriumProductInteractionsLoaded = true;
  const controllers = new Map();
  const initialize = (root) => {

  if (!root) return;
  controllers.get(root.id)?.abort();
  const controller = new AbortController();
  controllers.set(root.id, controller);
  const on = (target, type, handler) => target.addEventListener(type, handler, { signal: controller.signal });

  const matrix = root.querySelector('.opd__matrix');

  let cards = [...root.querySelectorAll('.opd__variant-card')];

  let shared = root.querySelector('[data-shared-input]');

  const errorRoot = root.querySelector('[data-error]');

  const money = new Intl.NumberFormat(root.dataset.language || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' });

  let active = cards.find((card) => !card.classList.contains('is-disabled')) || null;



  const showMedia = (id, button) => {
    let selected = null;
    root.querySelectorAll('.opd__slide').forEach(slide => {
      const activeSlide = slide.dataset.media === String(id);
      slide.hidden = !activeSlide;
      slide.classList.toggle('is-active', activeSlide);
      if (activeSlide) selected = slide;
    });
    root.querySelectorAll('.opd__thumbs button').forEach(thumb => thumb.classList.toggle('is-active', thumb === button || thumb.dataset.target === String(id)));
    const deferred = selected?.querySelector('template[data-media-template]');
    if (deferred) { selected.appendChild(deferred.content.cloneNode(true)); deferred.remove(); }
    const image = selected?.querySelector('img');
    if (image) { image.loading = 'eager'; image.fetchPriority = 'high'; }
  };

  const source = root.querySelector('[data-description-source]');

  if (source) {

    const wrapper = source.querySelector('.ovrium-desc') || source;

    const description = root.querySelector('[data-panel="description"]');

    const specifications = root.querySelector('[data-panel="specifications"]');

    const care = root.querySelector('[data-panel="care"]');

    const table = wrapper.querySelector('table[width="100%"],table');

    const rows = table ? [...table.querySelectorAll('tbody>tr')] : [];

    if (rows.length) {

      description.innerHTML = rows[0].querySelector('td')?.innerHTML || rows[0].innerHTML;

      specifications.innerHTML = rows.slice(1).map((row) => row.querySelector('td')?.innerHTML || row.innerHTML).join('');

    } else description.innerHTML = wrapper.innerHTML;

    const careLine = [...specifications.querySelectorAll('li,p')].find((node) => /^\s*Care Instructions?\s*:/i.test(node.textContent));

    if (careLine) {

      const careBlock = careLine.closest('li') || careLine;

      if (!care.textContent.trim()) care.innerHTML = careBlock.outerHTML;

      careBlock.remove();

    }

  }



  const formatWeight = (grams) => grams >= 1000 ? (Math.round(grams / 10) / 100) + ' kg' : Math.round(grams) + ' g';

  const select = (card) => {

    errorRoot.hidden = true;

    active = card;
    root.dataset.activeVariant = card.dataset.variant;

    cards.forEach((item) => item.classList.toggle('is-active', item === card));

    shared.value = card.dataset.qty;

    root.querySelector('[data-active-title]').textContent = card.dataset.title;

    const mediaId = card.querySelector('.opd__variant-colour').dataset.mediaId;

    if (mediaId) showMedia(mediaId, root.querySelector('[data-target="' + mediaId + '"]'));

  };

  const updateSelection = () => {

    errorRoot.hidden = true;

    if (active) active.dataset.qty = Math.max(0, Number(shared.value) || 0);

    let quantity = 0;

    let subtotal = 0;

    let weight = 0;

    cards.forEach((card) => {

      const count = Number(card.dataset.qty) || 0;

      const badge = card.querySelector('[data-badge]');

      badge.textContent = count;

      badge.hidden = count === 0;

      quantity += count;

      subtotal += count * Number(card.dataset.price);

      weight += count * (Number(card.dataset.weight) || 0);

    });

    root.querySelector('[data-total-qty]').textContent = quantity;

    root.querySelector('[data-subtotal]').textContent = money.format(subtotal / 100);

    root.querySelector('[data-total-weight]').textContent = formatWeight(weight);

  };

  const updateCartBadges = (cart) => {

    const quantities = new Map();

    (cart?.items || []).forEach((item) => quantities.set(String(item.variant_id), (quantities.get(String(item.variant_id)) || 0) + item.quantity));

    cards.forEach((card) => {

      const quantity = quantities.get(String(card.dataset.variant)) || 0;

      const badge = card.querySelector('[data-cart-badge]');

      badge.textContent = quantity;

      badge.hidden = quantity === 0;

    });

  };

  // Resolve controls at interaction time: translations can replace child nodes.
  const refreshControls = () => {
    const previousShared = shared;
    cards = [...root.querySelectorAll('.opd__variant-card')];
    shared = root.querySelector('[data-shared-input]');
    active = cards.find(card => card.dataset.variant === root.dataset.activeVariant)
      || cards.find(card => card.classList.contains('is-active'))
      || cards.find(card => !card.classList.contains('is-disabled')) || null;
    if (shared !== previousShared && active) shared.value = active.dataset.qty;
  };

  const addJsonItems = async (items) => {

    await window.OvriumCartRequest(matrix.dataset.cartUrl + '.js', {

      method: 'POST',

      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

      body: JSON.stringify({ items }),

    });


  };

  const addMultipartItem = async (item, properties, files, includeDetails) => {
    const data = new FormData();

    data.append('id', item.id);

    data.append('quantity', item.quantity || 1);

    data.append('properties[_Custom request]', 'Service');
    if (item.minimum) data.append('properties[_Minimum quantity]', item.minimum);
    Object.entries(item.properties || {}).forEach(([key,value]) => { if (value) data.append('properties[' + key + ']', value); });
    if (includeDetails) {
      Object.entries(properties).forEach(([key, value]) => { if (value) data.append('properties[_' + key + ']', value); });
      files.forEach((file, index) => data.append('properties[_Reference file ' + (index + 1) + ']', file, file.name));
    }

    return window.OvriumCartRequest(matrix.dataset.cartUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data }, 60000);

  };

  const fetchCart = async () => {

    return window.OvriumCartRequest(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });

  };

  const addSelected = async (custom) => {
    refreshControls();
    const selected = cards.map((card) => ({ id: Number(card.dataset.variant), quantity: Number(card.dataset.qty) || 0 })).filter((item) => item.quantity > 0);
    if (!custom && !selected.length) {
      errorRoot.textContent = root.dataset.quantityError;
      errorRoot.hidden = false;
      return;
    }

    const customization = custom ? window.OvriumCustomization : null;

    const validationError = customization?.validate?.();

    if (validationError) {

      errorRoot.textContent = validationError;

      errorRoot.hidden = false;

      return;

    }

    const properties = customization?.getProperties?.() || {};

    const files = customization?.getFiles?.() || [];

    const serviceItems = customization?.getServiceItems?.() || [];

    const button = custom ? document.querySelector('[data-custom-add]') : root.querySelector('[data-multi-add]');

    errorRoot.hidden = true;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    window.OvriumSetCartBusy?.(true);

    try {

      if (!custom) {
        await addJsonItems(selected);
      } else if (serviceItems.length) {
        const before = await fetchCart();
        const existingSetup = new Set(before.items.filter((item) => item.properties?.['_Setup fee'] === 'true').map((item) => item.properties['_Artwork setup group']));
        const items = serviceItems.filter((item) => item.properties?.['_Setup fee'] !== 'true' || !existingSetup.has(item.properties['_Artwork setup group']));
        const additions = [];
        try {
          for (let index = 0; index < items.length; index += 1) {
            const result = await addMultipartItem(items[index], properties, files, !items[index].properties?.['_Setup fee']);
            additions.push(result);
          }
        } catch (addError) {
          const previous = new Map(before.items.map((item) => [item.key, item.quantity]));
          const updates = Object.fromEntries(additions.filter((item) => item.key).map((item) => [item.key, previous.get(item.key) || 0]));
          if (Object.keys(updates).length) {
            await window.OvriumCartRequest(root.dataset.cartUpdateUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
          }
          throw addError;
        }
      }
      if (!custom) {
        cards.forEach((card) => {
          card.dataset.qty = '0';
          const badge = card.querySelector('[data-badge]');
          badge.textContent = '0';
          badge.hidden = true;
        });
        shared.value = 0;
        updateSelection();
      }
      const cart = await fetchCart();

      updateCartBadges(cart);

      window.dispatchEvent(new CustomEvent('ovrium:cart-added', { detail: { cart, customisation: custom } }));

    } catch (error) {
      errorRoot.textContent = error.message;
      errorRoot.hidden = false;
      if (custom) window.dispatchEvent(new CustomEvent('ovrium:custom-error', { detail: { message: error.message } }));
    } finally {

      button.disabled = false;
      button.removeAttribute('aria-busy');

      window.OvriumSetCartBusy?.(false);

    }

  };

  on(root, 'click', (event) => {
    const button = event.target.closest('button');
    if (!button || !root.contains(button) || button.disabled) return;
    refreshControls();
    if (button.matches('[data-target]')) {
      showMedia(button.dataset.target, button);
    } else if (button.matches('[data-tab]')) {
      root.querySelectorAll('[data-tab]').forEach(item => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-selected', String(item === button));
      });
      root.querySelectorAll('[data-panel]').forEach(item => item.classList.toggle('is-active', item.dataset.panel === button.dataset.tab));
    } else if (button.matches('.opd__variant-colour')) {
      const card = button.closest('.opd__variant-card');
      if (!card.classList.contains('is-disabled')) select(card);
    } else if (button.matches('[data-shared-minus], [data-shared-plus]')) {
      if (!active) return;
      event.preventDefault();
      shared.value = Math.max(0, Math.floor(Number(shared.value) || 0) + (button.matches('[data-shared-plus]') ? 1 : -1));
      updateSelection();
    } else if (button.matches('[data-multi-add]')) {
      addSelected(false);
    }
  });
  on(root, 'input', (event) => {
    if (!event.target.matches('[data-shared-input]')) return;
    refreshControls();
    shared.value = Math.max(0, Math.floor(Number(shared.value) || 0));
    updateSelection();
  });
  on(window, 'ovrium:add-customized-product', () => addSelected(true));
  on(window, 'ovrium:cart-updated', (event) => {
    refreshControls();
    updateCartBadges(event.detail?.cart);
  });

  errorRoot.hidden = true;

  refreshControls();
  if (active) select(active);
  root.querySelectorAll('[data-shared-minus], [data-shared-plus], [data-shared-input], [data-multi-add]').forEach(control => { control.disabled = !active; });

  updateSelection();

  };
  const initializeWithin = (container) => {
    if (container.matches?.('.opd')) initialize(container);
    container.querySelectorAll('.opd').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.opd').forEach(root => { controllers.get(root.id)?.abort(); controllers.delete(root.id); });
  });
})();


